import { StatefulRoom } from "@/lib/sendbird-calls";
import { VolumeX } from "lucide-react";

export const MediaContent = ({ room }: { room: StatefulRoom }) => {
  const { participants, localParticipant, remoteParticipants } = room;

  if (!remoteParticipants.length) {
    const p = localParticipant;
    return (
      <div className="flex h-[calc(100vh-152px)] w-full items-center justify-center p-4">
        <div className="relative h-full w-full">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="relative h-full max-h-full w-full max-w-full">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative aspect-video h-full max-h-full w-full max-w-full">
                  <video
                    autoPlay
                    playsInline
                    muted
                    ref={(el) => {
                      if (!el) return;
                      p.setMediaView(el);
                    }}
                    className="h-full w-full object-contain"
                    style={{
                      transform: `rotateY(180deg)`,
                    }}
                  />
                  {!p.isVideoEnabled && (
                    <div className="bg-navy-800 absolute inset-0 flex items-center justify-center">
                      <div
                        className="h-20 w-20 rounded-full bg-contain bg-center"
                        style={{
                          backgroundImage: `url(${p.user.profileUrl || "/icons/icon-avatar.svg"})`,
                        }}
                      />
                    </div>
                  )}
                  <div className="absolute bottom-0 left-0 flex h-6 items-center rounded-tr bg-[#212242] bg-opacity-70 px-2 py-1 text-white">
                    {!p.isAudioEnabled && <VolumeX className="mr-1 h-5 w-5" />}
                    {p.user.nickname}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-[calc(100vh-152px)] w-full items-center justify-center">
      <div className="grid h-full w-full grid-cols-1 gap-2 p-2 md:grid-cols-2 md:p-4">
        {participants.map((p) => (
          <div
            key={p.participantId}
            className="relative flex h-full w-full items-center justify-center bg-gray-900"
          >
            <div className="relative aspect-video h-full max-h-full w-full max-w-full">
              <video
                autoPlay
                playsInline
                muted={p.participantId === localParticipant.participantId}
                ref={(el) => {
                  if (!el) return;
                  if (p.participantId === localParticipant.participantId) {
                    localParticipant
                      .setMediaView(el)
                      .then(() => {
                        //
                      })
                      .catch((e) => {
                        console.error("local participant error", e);
                      });
                  } else {
                    p.setMediaView(el)
                      .then(() => {
                        //
                      })
                      .catch((e) => {
                        console.error("remote participant error", e);
                      });
                  }
                }}
                className="h-full w-full rounded-lg object-contain"
                style={{
                  transform: `rotateY(${
                    p.participantId === localParticipant.participantId ? 180 : 0
                  }deg)`,
                }}
              />
              {!p.isVideoEnabled && (
                <div className="bg-navy-800 absolute inset-0 flex items-center justify-center rounded-lg">
                  <div
                    className="h-20 w-20 rounded-full bg-contain bg-center"
                    style={{
                      backgroundImage: `url(${
                        p.user.profileUrl || "/icons/icon-avatar.svg"
                      })`,
                    }}
                  />
                </div>
              )}
              <div className="absolute bottom-0 left-0 flex h-6 items-center rounded-tr bg-[#212242] bg-opacity-70 px-2 py-1 text-white">
                {!p.isAudioEnabled && <VolumeX className="mr-1 h-5 w-5" />}
                {p.user.nickname}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
